import React from 'react';
import {Table, Divider, message, Button, Popconfirm} from 'antd';
import {deleteServiceCase, getPagedServiceCaseList} from "../../../action/service_case_action";
import {deleteQa} from "../../../action/qa_action";

class CaseList extends React.Component{
    static STATE_STRUCT = () => {
        return {
            listData: [],
            pageSize: 10,
            pageIndex: 0,
            total: 0,
            tableLoading: false,
        }
    };

    state = CaseList.STATE_STRUCT();

    componentDidMount() {
        this._getData(0);
    }

    _getData = (pageIndex) => {
        this.setState({tableLoading: true});
        getPagedServiceCaseList(pageIndex, this.state.pageSize, (data, msg)  => {
            if (data) {
                this.setState({tableLoading: false, listData: data.data, total: data.size, pageIndex: pageIndex});
            } else{
                this.setState({tableLoading: false});
                message.error(msg ? msg : "获取例子信息失败");
            }
        })
    };

    render() {
        const dataSource = this.state.listData;

        const columns = [
            {
                title: 'id',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '简介',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '操作',
                key: 'device_status',
                render: (record) => (
                    <div>
                        <a onClick={()=>this.props.history.push("/case/edit/" + record.id)}>编辑</a>
                        <Divider type='vertical'/>
                        <Popconfirm
                            title="是否确认删除?"
                            onConfirm={() => {
                                deleteServiceCase(record.id, (res, msg) => {
                                    if (res) {
                                        message.success("删除成功");
                                        this._getData(this.state.pageIndex);
                                    }else
                                        message.error(msg ? msg : "删除失败");
                                });
                            }}
                            okText="是"
                            cancelText="否">
                            <a>删除</a>
                        </Popconfirm>
                    </div>
                )
            }
        ];
        return (
            <div>
                <Button onClick={() => this.props.history.push("/case/add")}>添加例子</Button>
                <Table style={{marginTop: 20}} loading={this.state.tableLoading} columns={columns} dataSource={dataSource} rowKey={record=>record.id}
                       pagination={{
                           current: this.state.pageIndex + 1,
                           defaultPageSize: this.state.pageSize,
                           total : this.state.total,
                           onChange: (page, si) => {
                               this._getData(page - 1);
                           }
                       }} />
            </div>

        );
    }
}

export default CaseList;
